import { useSyncExternalStore } from 'react'

const POLL_MS = 15_000
const TIMEOUT_MS = 5_000

let down = false
let probing = false
let healthUrl = '/api/v1/health'
const listeners = new Set<() => void>()

export async function isReachable(url: string): Promise<boolean> {
  const ctrl = new AbortController()
  const timer = window.setTimeout(() => ctrl.abort(), TIMEOUT_MS)
  try {
    const res = await fetch(url, { cache: 'no-store', signal: ctrl.signal })
    return res.status < 500
  } catch {
    return false
  } finally {
    window.clearTimeout(timer)
  }
}

function poll() {
  window.setTimeout(() => {
    void isReachable(healthUrl).then((ok) => (ok ? window.location.reload() : poll()))
  }, POLL_MS)
}

export function reportOutage(url?: string): void {
  if (url) healthUrl = url
  if (down || probing) return
  probing = true
  void isReachable(healthUrl).then((ok) => {
    probing = false
    if (ok || down) return
    down = true
    listeners.forEach((l) => l())
    poll()
  })
}

export function isOutageStatus(status: number): boolean {
  return status === 502 || status === 503 || status === 504
}

const subscribe = (l: () => void) => {
  listeners.add(l)
  return () => listeners.delete(l)
}

export function useOutage(): boolean {
  return useSyncExternalStore(subscribe, () => down, () => false)
}
